'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _tripadvisorLocales = require('tripadvisor-locales');

var _yelpLocales = require('yelp-locales');

var _foursquareLocales = require('foursquare-locales');

var DEFAULT_LOCALE = 'en_US';

exports.default = {
    idToUrl: function idToUrl(platform, id) {
        var locale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT_LOCALE;
        var byUserName = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

        var url = null;

        switch (platform) {
            case 'facebook':
                url = 'https://www.facebook.com/' + id;
                break;
            case 'foursquare':
                url = _foursquareLocales.FoursquareLocales.bestPageUrlFor({ locale: locale, venueId: id });
                break;
            case 'yelp':
                url = _yelpLocales.YelpLocales.bestPageUrlFor({ locale: locale, id: id });
                break;
            case 'tripadvisor':
                url = _tripadvisorLocales.TripadvisorLocales.bestPageUrlFor({ locale: locale, locationId: id });
                break;
            case 'twitter':
                if (byUserName) {
                    url = 'https://twitter.com/' + id;
                } else {
                    url = 'https://twitter.com/intent/user?user_id=' + id;
                }
                break;
            case 'instagram':
                url = 'https://www.instagram.com/' + id;
                break;
        }

        return url;
    }
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/wixrest-utils/dist/SocialPlatformConverter.js
// module id = 307
// module chunks = 0